export const linearBiomassCoefficientValuesKg = {
  min: 10,
  max: 60,
};

export const linearBiomassCoefficientValuesLb = {
  min: 20,
  max: 120,
};
